import { render, staticRenderFns } from "./shopTraveler.vue?vue&type=template&id=c45518ee&"
import script from "./shopTraveler.vue?vue&type=script&lang=js&"
export * from "./shopTraveler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports